export const ActiveColumnRenderer = (company: Record<any, any>): string => {
  return company.active ? 'Yes' : 'No';
};
